// ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem("currentUser");
  return isAuthenticated ? children : <Navigate to="/Login" replace />;
};

export default ProtectedRoute;
